import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=509fb474&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509fb474",
  null
  
)

export default component.exports
import {QCard,QCardSection,QSeparator,QIcon,QBtn,QSpinner} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QSeparator,QIcon,QBtn,QSpinner})
